import React, {Component} from 'react';
import {BigButtonTool} from "../../oneLineToolSpace";
import menuAudioIcon from "../../../components/image/menuaudio.png";
import MedialSelect from "../components/medialSelect";
import localUpload from "../components/img/localUpload.png";
import resourceSelect from "../components/img/resourceSelect.png";
import CurrencyResourceDialog from "../../../../resource/view/dialog/CurrencyResourceDialog";
import BaseComponent from "../../../../../base/BaseComponent";
import {permissionCheck, uuid} from '../../../../../utils'
import address from "../components/img/address.png";
export const buildInsertAudioHtml = ({url})=>{
    return `<img src="/cm-sites/images/audio.png" width="90" alias-label="audio" audio-src="${url}" />`;
};

class AudioTool extends BaseComponent {

    state = {
        isHover: "none",
        dialog: false,
        dialogKey: uuid(),
    };

    insertAudioToContent(fileList,call){
        let imgHTML = '';
        fileList && fileList.map(file => {
            imgHTML += buildInsertAudioHtml({
                ...file,
                url: file.path

            });
        });
        let isSuccess = true;
        if(imgHTML){
            isSuccess = this.props.editor.rmtExecCommand("inserthtml", imgHTML);
        }
        call&&call(isSuccess)
    }

    render() {
        return (<>
            <div
                onMouseEnter={() => {this.setState({isHover: "block"})}}
                onMouseLeave={() => this.setState({isHover: "none"})}
                onClick={()=>{this.setState({isHover: "none"})}}
                style={{position:'relative'}}>
                <BigButtonTool
                    src={menuAudioIcon} text={"音频"} height={this.props.height} width={this.props.width} />
                {/*音频下拉框*/}
                <div style={{
                    position: 'absolute',
                    top: '58px',
                    left: "95px",
                    zIndex: 999,
                    display: this.state.isHover
                }}>
                    <MedialSelect >
                        <div className={'selectList'}
                             style={{width:'119px',height:'32px',padding:'0 10px',lineHeight:"32px"}}
                             onClick={()=>{this.setState({dialog:true})}}>
                            <img src={localUpload} style={{marginRight:"8px"}}/>
                            <span>本地上传</span>
                        </div>
                        {permissionCheck('right_to_use_zyk')?
                            <div className={'selectList'} onClick={()=>this.resourceDialog.show()}
                                 style={{width:'119px',height:'32px',padding:'0 10px',lineHeight:"32px"}}>
                            <img src={resourceSelect} style={{marginRight:"8px"}}/>
                            <span>资源库选择</span>
                        </div>:null}
                        <div className={'selectList'}
                             style={{width: '119px', height: '32px', padding: '0 10px', lineHeight: "32px"}}
                             onClick={()=>{

                             }}>
                            <img src={address} style={{marginRight: "8px"}}/>
                            <span>地址插入</span>
                        </div>

                    </MedialSelect>
                </div>
            </div>
                <CurrencyResourceDialog
                    onOk={(checkedData) => {
                        this.insertAudioToContent(checkedData);
                    }}
                    indexName={"audio"}
                    ref={resourceDialog => this.resourceDialog = resourceDialog}/>

            </>
        );
    }
}

export default AudioTool;